function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "box_1_",
  "data-name": "box (1)",
  transform: "translate(-74.85 -74.85)"
}, React.createElement("path", {
  id: "Path_1220",
  "data-name": "Path 1220",
  d: "M85.757,83.851a9.878,9.878,0,0,1,3.261.549.425.425,0,0,0,.28-.8,10.764,10.764,0,0,0-13.65,13.846.425.425,0,0,0,.8-.292,9.913,9.913,0,0,1,9.31-13.3Z",
  transform: "translate(0 -7.514)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_1221",
  "data-name": "Path 1221",
  d: "M114.568,201.81a.425.425,0,0,0,.762.18l.912-1.237a10.657,10.657,0,0,0,6.133,1.918,10.762,10.762,0,0,0,9.929-14.9.425.425,0,0,0-.785.328,9.908,9.908,0,0,1-14.772,11.969l1.347-1.829a.425.425,0,0,0-.4-.674l-3.339.434a.425.425,0,0,0-.365.495Zm2.249-3.274-1,1.363,0,0,0,.007-.569.772-.329-1.9Z",
  transform: "translate(-36.617 -105.671)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_1222",
  "data-name": "Path 1222",
  d: "M339.32,78.1a.425.425,0,0,0-.425-.425h-2.249V75.425a.425.425,0,0,0-.851,0v2.249h-2.37a.425.425,0,0,0,0,.851h2.37V80.9a.425.425,0,0,0,.851,0v-2.37H338.9A.425.425,0,0,0,339.32,78.1Z",
  transform: "translate(-242.321)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_1223",
  "data-name": "Path 1223",
  d: "M150.415,183.088h10.19a.441.441,0,0,0,.428-.441V176.4h.547a.438.438,0,0,0,.425-.439v-2.523a.439.439,0,0,0-.425-.441H149.425a.439.439,0,0,0-.425.441v2.523a.438.438,0,0,0,.425.439h.547v6.244A.454.454,0,0,0,150.415,183.088Zm9.767-.851h-9.359V176.4h2.917c3.039.013.741.021,3.525,0h2.917Zm-10.331-6.685v-1.7h11.3v1.7Z",
  transform: "translate(-69.503 -92.044)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
}));

var SvgPackage = function SvgPackage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22.3,
    height: 22.3,
    viewBox: "0 0 22.3 22.3",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/package.80204725.svg";
export { ForwardRef as ReactComponent };